import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.directoryFamilyForm.alertTitle, 'Directory family'),
  categories: () => __(translations.directoryFamilyForm.categories, 'Categories'),
};
